import React from 'react';
import {getWorkCode} from './occupation-codes'

const TableCellInteractive = ({url, item, classes, onClick}) => {
    const workCode = getWorkCode(item);

    return (
        <div
            data-id={url}
            data-name={workCode.code}
            className={classes + " table__cell"}
            onClick={onClick}
        >
            <div
                className="cell-content"
                style={{ pointerEvents: 'none' }}
            >
                {workCode.letter}
            </div>
        </div>
    )
}

export default TableCellInteractive;
